import React, { ReactNode } from 'react'

import { MarginProps } from 'styled-system'

import { Text } from 'Components/UI'

type Props = MarginProps & {
  centered?: boolean
  inverse?: boolean
  text: ReactNode
}

function CTAHeadline({ centered, inverse, text, ...rest }: Props) {
  return (
    <Text
      {...rest}
      bold
      center={centered}
      important={!inverse}
      inverse={inverse}
      screen24
    >
      {text}
    </Text>
  )
}

export default CTAHeadline
